import React from "react";
import { Table } from "reactstrap";
import { object } from "prop-types";
import moment from "moment";

const TrueMatchesInfoTable = ({ singleClientReportDetails }) => {
  const clientName = singleClientReportDetails.clientName;
  const linkLabel = singleClientReportDetails.linkLabel;
  const rows =
    singleClientReportDetails.trueMatchWatchListSearchingDecisions.map(
      (entry, index) => (
        <tr key={index}>
          <td className="font-weight-bolder">{entry.watchList.name}</td>
          <td>{clientName}</td>
          <td>
            {moment.utc(entry.checkDate).local().format("DD.MM.YYYY HH:mm:ss")}
          </td>
          <td>
            {moment.utc(entry.createDate).local().format("DD.MM.YYYY HH:mm:ss")}
          </td>
          <td>{entry.user.name}</td>
          <td>{entry.watchListSearchingDecisionComment.comment}</td>
          <td>
            <a href={entry.monitoringQueueLink} target="_blank">
              {linkLabel}
            </a>
          </td>
        </tr>
      )
    );
  return (
    <Table className="single-client-report-entries-table">
      <thead>
        <tr>
          <th>{singleClientReportDetails.watchlistNameLabel}</th>
          <th>{singleClientReportDetails.clientNameLabel}</th>
          <th>{singleClientReportDetails.checkDateLabel}</th>
          <th>{singleClientReportDetails.decisionDateLabel}</th>
          <th>{singleClientReportDetails.userLabel}</th>
          <th>{singleClientReportDetails.commentLabel}</th>
          <th>{linkLabel}</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
      <tfoot />
    </Table>
  );
};
TrueMatchesInfoTable.propTypes = {
  singleClientReportDetails: object.isRequired,
};

export default TrueMatchesInfoTable;



// WEBPACK FOOTER //
// ./src/features/reports/components/single-client-details/true-matches-info-table/TrueMatchesInfoTable.jsx